export const SHOPEE_REALTIME_EVENT = "vmass:data-changed";

const SHOPEE_WORKSPACE_SCOPES = new Set([
  "ecommerce",
  "orders",
  "products",
  "inventory",
  "returns",
  "finance",
  "dashboard"
]);

const text = value => String(value || "").trim();

const payloadFor = event =>
  event && typeof event.payload === "object" && !Array.isArray(event.payload)
    ? event.payload
    : {};

export const getShopeeEventShopId = event => {
  const payload = payloadFor(event);
  return text(payload.shopId || payload.shop_id);
};

export const isShopeeWorkspaceEvent = event => {
  if (!event || !SHOPEE_WORKSPACE_SCOPES.has(text(event.scope))) return false;

  const payload = payloadFor(event);
  if (payload.provider !== undefined) {
    return text(payload.provider).toLowerCase() === "shopee";
  }

  if (text(payload.source).toLowerCase().startsWith("shopee-")) return true;

  return /^\/api\/shopee(?:\/|$)/.test(text(payload.path));
};

export const shouldRefreshShopeeWorkspace = (event, selectedShopId) => {
  if (!isShopeeWorkspaceEvent(event)) return false;

  const eventShopId = getShopeeEventShopId(event);
  const activeShopId = text(selectedShopId);
  return !eventShopId || !activeShopId || activeShopId === "ALL" || eventShopId === activeShopId;
};

export const isShopeeNewOrderEvent = event =>
  isShopeeWorkspaceEvent(event) && text(event && event.action) === "order-created";
